import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'seo-logged_out_store_type-action_category_impression';

/**
 * This will be called when a store type section is viewed. This is for logged out discover page only
 */
export function trackSeoLoggedOutStoreTypeActionCategoryImpression(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
